import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { WerkbonComponent } from './werkbon.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import { MatSelectModule} from '@angular/material/select';
import { MultiSelectModule} from 'primeng/multiselect';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule, } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {ListboxModule} from 'primeng/listbox';
import {DropdownModule} from 'primeng/dropdown';
import {CalendarModule} from 'primeng/calendar';
import {TwoDigitDecimaNumberDirective} from '../../../core/directive';
import { SignaturePadModule } from 'angular2-signaturepad';
import { AuthGuard } from 'app/core/services/auth.guard';
const routes = [
    {
        path     : 'buitendienst/werkbon',
        component: WerkbonComponent,
        canActivate: [AuthGuard] ,
        data: { roles: ['mws'] } 
        
    },
    { 
        path: 'buitendienst/werkbon/:medewerkerid', 
        component: WerkbonComponent,
        canActivate: [AuthGuard]  
    }
];

@NgModule({
    declarations: [
        WerkbonComponent,
        TwoDigitDecimaNumberDirective
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatRadioModule,
        MatTableModule,
        MatTabsModule,
        MatSortModule,
        MatButtonModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatSelectModule,
        MatNativeDateModule,
        TranslateModule,
        MatInputModule,
        FuseSharedModule,
        MultiSelectModule,
        MatDatepickerModule,        
        ListboxModule,
        DropdownModule,
        CalendarModule,
        SignaturePadModule 
    ],
    exports     : [
        WerkbonComponent
    ]
})

export class WerkbonModule
{
}
